var _ellipse, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _ellipse2, _ellipse3, _path13, _path14, _path15, _path16, _path17, _path18, _path19;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCurriculumLandingStairway1 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 600 367",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 212.5,
    cy: 333.5,
    fill: "var(--curriculum-bg-color-landing-stairway-floor)",
    rx: 212.5,
    ry: 11.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F4D4B8",
    d: "M87.786 315.778c1.482-2.222.988-2.778.988-2.778h8.398s-.317 3.08 0 5c.302 1.822 1.24 2.611 1.483 4.444.17 1.288.683 2.283 0 3.334-.614.943-2.47 1.111-2.47 1.111H78.892v-5.556s7.41-3.333 8.893-5.555M74.446 328v-5s-1.634.417-2.47 1.111c-1.118.93-1.976 3.333-1.976 3.333zm60.054-10c1.5-2 .5-5 .5-5h9s.678 1.772 1 3.5c.305 1.64 0 3.5 3.5 6 .953.681 1.192 3.055.5 4-.621.849-2.5 1-2.5 1l-19.5.5v-5.5s6-2.5 7.5-4.5m-10 10.5V324s-1.654.375-2.5 1c-1.132.837-2 3-2 3zM111 135v-2.5l6.5-1.5.5 4h4.5s-4.657 7.172-7 6-5.157-4.828-7.5-6z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M106.34 134.994c-2.157.019-6.81.17-9.528 1.088-4.468 1.508-6.763 2.64-10.798 5.39-6.697 4.565-11.93 16.938-11.93 16.938l-2.691 8.934L69 180.694s.53 1.542 2.393 2.726c1.87 1.189 14.62 7.08 14.62 7.08h5.633l-.304 9.334c17.239 5.962 46.202 2.63 46.703-2.824l.312-9.727-2.726-21.75c.609 4.426 3.534 21.56 12.369 21.75 7.476.16 15-11.902 15-11.902l8-20.881-11-11.5-8 15.41-5-8.91s-4.007-5.463-7.5-8.5c-2.807-2.441-9.5-4.5-9.5-4.5l-7-1.502s-1.5 2-4.5 4c-1.835 1.223-3 1-3 1-1.5-1-3.785-2.603-3.785-2.603l-4.215-2.399s-.441-.008-1.16-.002m-12.461 25.512v15.074L87.5 174.5s.217-2.227.727-4.443c.207-.903.464-1.804.773-2.551 1.273-3.08 4.879-7 4.879-7",
    style: {
      fill: "#f9cfa6"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.5,
    d: "m152 158.5 8-15.5 11 12"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    d: "m110.001 178.5-.056 10s12.055 4 13.556 3.5.499-.5.499-.5m3.5-10s1.502.5-.499 1-9 .5-9 .5M129 185s1.001.5-.499 1-10-.5-10-.5m8.5 2.5s1.001 1-1 1-8-1.5-8-1.5m-2.001-8s1.971-1.039 3-2c.914-.853 2-2.5 2-2.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4D4B8",
    d: "M110.001 178.499s12.308-6.862 10.5-3c-.39.834-1.17 1.595-2 2.225-1.426 1.082-3 1.775-3 1.775l11.5 1.5s2.001 1 0 1.5-9 .5-9 .5l10.5 1.5s1.5 1 0 1.5-10-.5-10-.5l8 1.5s1.501 2-.5 2-8-1.5-8-1.5l6 3s1.001 1-.5 1.5-13.556-3.5-13.556-3.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    d: "m161.025 143.251 7.477 8.749s11.828-6.866 12.777-8.339.098-.743.098-.743m-3.541-10.139s1.601-.715.228 1.122-7.316 6.936-7.316 6.936m10.641-6.495s1.176-.35.228 1.123-8.816 6.905-8.816 6.905m8.844-4.295s1.501.03-.197 1.488c-1.699 1.457-7.77 4.689-7.77 4.689"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4D4B8",
    d: "M162.118 143.6s-5.011-10.514-1.118-8.593c1 .493 5.5 4.06 5.5 4.06l10-6.567s2.986-.795 1.724 1.068-6.871 7.099-6.871 7.099l9.438-6.76s1.885-.391 1.024 1.097-8.355 7.116-8.355 7.116l7.435-4.889s2.567.339.964 1.836-7.435 4.889-7.435 4.889l6.856-2.296s1.484-.018.623 1.47c-.862 1.489-13.402 8.359-13.402 8.359z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.5,
    d: "M168.971 145.526s.054-2.064-.31-3.424c-.323-1.208-2.118-2.938-2.118-2.938M94 160.5v15"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#94B1EB",
    d: "M76.086 262.22c1.118-24.967 15.414-63.693 15.414-63.693s-1.43 4.472 21.043 4.473c22.474.001 24.971-5 24.971-5s-1.489 29.793 0 48.787C139.571 273.018 150 313 150 313h-30.964l-11.487-74.178-7.491 23.398 9.988 50.78H81.579s-6.386-30.854-5.493-50.78"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.5,
    d: "M91.868 199.965S91.33 202.999 113.5 203s24.184-5 24.184-5-1.469 29.41 0 48.16C139.712 272.054 150 311.522 150 311.522m-67 1.475s8.404.007 13.794 0c5.583-.007 13.302 0 13.302 0L105.5 287l-5-25 7.625-23.703M109.5 178.5 87 175"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.5,
    d: "m92 191-.5 8.5s1 3.5 23 3.5 23.5-5.5 23.5-5.5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#F4D4B8",
    d: "M123.717 119.888c-3.144 9.028-3.194 10.114-11.196 13.124-7.143-2.463-10.287-3.282-11.144-13.679 2.286-10.394 8.633-14.958 15.103-14.958 4.001 1.915 9.895 5.721 7.237 15.513"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5,
    d: "M109.547 124.211c2.6 1.916 4.159 2.476 7.228 1.95m-3.338-3.056h3.336l-.278-6.408c.434-.435.734-.946 1.112-1.393.47-.557.625-.595 1.112-.836 1.168-.577 3.336 0 3.336 0l.556 1.393m-15.569-.278s1.287-.859 2.224-1.115c1.257-.343 2.118-.463 3.337 0 .873.333 1.946 1.393 1.946 1.393m-11.61 10.387s3.125 5.772 9.107 6.33c1.209.112 3.059-.558 3.059-.558"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 119.555,
    cy: 117.797,
    fill: "#0F0F0F",
    rx: 0.834,
    ry: 0.836
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.586,
    cy: 117.18,
    fill: "#0F0F0F",
    rx: 0.834,
    ry: 0.836
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M110.702 96.884c-1.374-2.107-4.44-3-7.41-1.995-3.413 1.154-5.408 4.375-4.455 7.195.325.961.951 1.752 1.77 2.331-1.141 2.172-1.793 4.628-1.793 7.115 0 1.271.023 2.909.568 3.12 1.001 0 1.644-.214 2.197-.589l.07.015s.821 5.905-.567 9.644q-.119.321-.225.624c-.316.893-.596 1.682-1.193 2.496-1.167 1.591-4.539 3.688-4.539 3.688s2.925-.187 3.971-.567c2.067-.751 2.844-2.225 3.688-4.255.309-.745.567-1.986.567-1.986v-5.957c0-.893 1.135-1.985 1.135-1.985l1.111-5.279q.323-.228.668-.467l8.182-4.522c.922-.316 1.78-.503 2.521-.504 1.132 0 1.879 1.154 2.574 2.228.369.571.724 1.119 1.114 1.459.857.748 1.586 1.55 2.2 2.27q.335.394.626.747h.001l.348.419c.161.672.217 1.707-.009 3.302-.614 4.33-.568 5.956-.568 5.956s.805-1.342 1.372-2.193c.481-.722.384-4.765.343-5.975.488.191.698-.514.697-2.82 0-1.821-.353-3.558-.995-5.146 1.674-.478 3.012-1.595 3.545-3.169.953-2.82-1.042-6.041-4.455-7.195-3.184-1.076-6.478.026-7.68 2.468a13.3 13.3 0 0 0-3.876-.573q-.762 0-1.503.1",
    clipRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#83BB9E",
    d: "M74.61 322.5s1.176-.709 2-1c.938-.331 2.5-.5 2.5-.5v7.5h-4.5z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#83BB9E",
    d: "m70.61 326-.5 1 30.5-.5s.5 1.195.5 2-.5 2-.5 2h-31s-.385-.579-.5-1c-.154-.565-.139-.931 0-1.5.23-.949 1.5-2 1.5-2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M100.609 326.5h-21.5v-5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#83BB9E",
    d: "M124.61 323.5s-1.823.791-1 .5c.39-.138.924-1.515 2-2 1.513-.682 3.108-1 3.108-1l.002 8h-4.5z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#83BB9E",
    d: "m121.109 326.5-.5 1 29.61-.5s.5 1.195.5 2-.5 2-.5 2h-31s-.385-.579-.5-1c-.154-.565-.138-.931 0-1.5.231-.949 2.39-2 2.39-2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.5,
    d: "M150.219 327h-21.5v-5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCurriculumLandingStairway1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/curriculum-landing-stairway-1.8ba90d5a3938debeeb0da3e719a37baa.svg";